import { Component, OnInit } from '@angular/core';

import { BaseComponent } from '../../base/base.component';
import { ErrorService } from '../../../services/error/error.service';
import { WizardService } from '../../../services/wizard/wizard.service';

// TODO-COMMON
// import { IUser } from '@app/core/interfaces';

import { AvailabilityType } from 'common-lib';
import { IWizardContact, IWizardResponse, IWizardSkillMode } from '../../../models';

import * as _ from 'lodash';
import moment_ from 'moment-timezone';
const moment = moment_;

/**
 * Displayed before sending email invitations requesting to schedule meeting
 */
@Component({
    selector: 'wizard-confirmation',
    templateUrl: './confirmation.component.html',
    styleUrls: ['./confirmation.component.scss', '../../form-styles.scss']
})
export class ConfirmationComponent extends BaseComponent implements OnInit {
    public availabilityUsers: IWizardContact[] = undefined;
    public availabilityTypeText = '';
    public selectedContacts: any[];
    public vipContacts: IWizardContact[] = [];
    public currentUser: any; // TODO: use IUser
    public isUpdatingMeeting = false;
    public confirmationState?: IWizardSkillMode;
    public originalContacts: IWizardContact[];
    public timezone = moment.tz.guess();

    constructor(public wizardService: WizardService, public errorService: ErrorService) {
        super();
        this.currentUser = this.wizardService.currentUser;
    }

    ngOnInit() {
        this.confirmationState = this.getConfirmationState();
        this.determineAvailabilityType(this.wizardService.responseData);
        this.getCollectiveAvailabilityUsers(this.wizardService.responseData);
        this.originalContacts = this.wizardService.responseData.originalAttendees;
        this.selectedContacts = this.wizardService.selection;
        this.vipContacts = this.wizardService.vipContacts;
        this.isUpdatingMeeting = !!this.wizardService.options.taskId;
    }

    private getConfirmationState() {
        if (this.data?.mode) return this.data.mode;
        if (this.wizardService.responseData?.mode) return this.wizardService.responseData.mode;
        return undefined;
    }

    private determineAvailabilityType(data: IWizardResponse['data']) {
        const availabilityOption = data.availabilityType;
        this.availabilityTypeText = this.getSimpleAvailabilityType(availabilityOption);

        // if collective meeting, but NOT pre-select collective, and only 1 contact invited, treat it as a standard meeting:
        if (
            this.availabilityTypeText === 'collective' &&
            this.wizardService.options.contacts.length === 1 &&
            availabilityOption !== 'some-internal-users-collective'
        ) {
            this.availabilityTypeText = 'your';
        }
    }

    private getCollectiveAvailabilityUsers(data: IWizardResponse['data']) {
        if (!data.attendees) return;

        const internalAvailabilityUsers = data.attendees
            .filter((attendee) => attendee.availabilityGroupType === 'internal-availability')
            .map((attendee) => attendee.contact);

        if (internalAvailabilityUsers) {
            this.availabilityUsers = internalAvailabilityUsers;

            this.availabilityTypeText = this.updateAvailabilityTypeTextIfIsOnBehalf(
                this.availabilityTypeText,
                internalAvailabilityUsers
            );
        }
    }

    private updateAvailabilityTypeTextIfIsOnBehalf(availabilityTypeText: string, availabilityUsers: IWizardContact[]) {
        return this.isOnBehalf(availabilityTypeText, availabilityUsers)
            ? availabilityUsers[0].name + "'s"
            : availabilityTypeText;
    }

    private isOnBehalf(availabilityTypeText: string, availabilityUsers: IWizardContact[]) {
        return (
            availabilityTypeText === 'on-behalf' &&
            availabilityUsers &&
            availabilityUsers.length === 1 &&
            availabilityUsers[0].name
        );
    }

    /** This method is from meetingTypesService */
    private getSimpleAvailabilityType(availabilityType?: AvailabilityType) {
        switch (availabilityType) {
            case 'all-internal-users-round-robin':
            case 'all-internal-users-round-robin-no-organizer':
            case 'some-internal-users-round-robin':
                return 'round-robin';
            case 'all-internal-users-collective':
            case 'all-internal-users-collective-no-organizer':
            case 'some-internal-users-collective':
                return 'collective';
            case 'on-behalf':
                return 'on-behalf';
            case 'external-on-behalf':
                return 'external on-behalf';
            default:
                return 'your';
        }
    }
}
